import { FC, useCallback } from 'react';

import useSWRMutation from 'swr/mutation';

import { userService } from 'v2/api/userService';
import { UserRolesFormControl } from 'v2/components/form/userRolesFormControl/UserRolesFormControl';
import { UserRole } from 'v2/constants';
import { UserModel } from 'v2/types/UserModel';
import { handleHttpError } from 'v2/utils';

interface UserSettingsRolesColumnProps {
  user: UserModel;
  onRevalidate: VoidFunction;
}

export const UserSettingsRolesColumn: FC<UserSettingsRolesColumnProps> = ({ user, onRevalidate }) => {
  const { trigger } = useSWRMutation(['updateUser', user.id], userService.updateUser, {
    onSuccess: () => {
      onRevalidate();
    },
    onError: handleHttpError,
  });

  const handleUpdateRoles = useCallback(
    (roles: UserRole[]) => {
      trigger({ ...user, roles });
    },
    [trigger, user]
  );

  const handleDeleteRole = useCallback(
    (role: UserRole) => {
      trigger({ ...user, roles: user.roles.filter((r) => r !== role) });
    },
    [trigger, user]
  );

  return <UserRolesFormControl roles={user.roles} onUpdate={handleUpdateRoles} onDelete={handleDeleteRole} />;
};
